import React from 'react';
import { func_cookieSetting, getObjectPropertyValue, isDateValid, isNumberOrStringValid, isNumberValid, isStringTrimNotEmpty, reformatNumberWithCommas, func_datetime, isNotNullUndefined } from 'functions';

export function useTableColumns() {

    function getColumn_comId() {
        let columnClassName = "table__column-com-id";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "COM ID",
            id: "comId",
            accessor: "ComId",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberOrStringValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumn_companyName() {
        let columnClassName = "table__column-company-name";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Company Name",
            id: "companyName",
            accessor: "ComName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 400
        }
    }

    function getColumn_isTrial() {
        let columnClassName = "table__column-is-trial";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial",
            id: "isTrial",
            accessor: "IsTrial",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNotNullUndefined(value)? (value? "Yes":"No"): "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 100
        }
    }

    function getColumns_creationDate() {
        let columnClassName = "table__column-creation-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Creation Date",
            id: "creationDate",
            accessor: "CreationDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let cell = getObjectPropertyValue(props, "cell");
                let value = getObjectPropertyValue(cell, "value");
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumns_lastTrialExtendedDate() {
        let columnClassName = "table__column-last-trial-extended-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Last Trial Extended Date",
            id: "lastTrialExtendedDate",
            accessor: "LastTrialExtendDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let cell = getObjectPropertyValue(props, "cell");
                let value = getObjectPropertyValue(cell, "value");
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_lastExtendedBy() {
        let columnClassName = "table__column-last-extended-by";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Last Extended By",
            id: "lastExtendedBy",
            accessor: "LastExtendPerson",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumns_trialExpiryDate() {
        let columnClassName = "table__column-trial-expiry-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial Expiry Date",
            id: "trialExpiryDate",
            accessor: "TrialExpiryDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let cell = getObjectPropertyValue(props, "cell");
                let value = getObjectPropertyValue(cell, "value");
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }


    return [
        getColumn_comId(),
        getColumn_companyName(),
        getColumn_isTrial(),
        getColumns_creationDate(),
        getColumns_lastTrialExtendedDate(),
        getColumn_lastExtendedBy(),
        getColumns_trialExpiryDate(),
    ]
}